import {
  ChangeDetectionStrategy,
  Component,
  computed,
  DestroyRef,
  effect,
  inject,
  OnInit,
  signal,
  WritableSignal,
} from '@angular/core';
import { LnProductsCarouselComponent } from '@components/ln-products-carousel/ln-products-carousel.component';
import { ProductServiceParamsInterface } from '@interfaces/products/product_service_params_interface';
import { ProductsService } from '@core/services/products/products.service';
import { SpecialProductInterface } from '@interfaces/products/special_product_interface';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ApiResponse } from '@interfaces/api/api.interface';
import { GetSpecialProductsData } from '@interfaces/products/get_special_products_data';
import { MenuActions } from '../../states/menu_actions';
import { SkeletonComponent } from '@components/skeleton/skeleton.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { LanguageService } from '@core/services/language/language.service';

@Component({
  selector: 'ln-artisans-designers-created-products',
  imports: [LnProductsCarouselComponent, SkeletonComponent, TranslocoPipe],
  templateUrl: './artisans-designers-created-products.component.html',
  styleUrl: './artisans-designers-created-products.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArtisansDesignersCreatedProductsComponent implements OnInit {
  private TAG = 'ArtisansDesignersCreatedProductsComponent';
  private productService = inject(ProductsService);
  products: WritableSignal<SpecialProductInterface[]> = signal([]);
  private readonly MIN_PRODUCT_SIZE = 20;
  showSeeMore = computed(() => this.products().length >= this.MIN_PRODUCT_SIZE);
  protected gettingProducts: WritableSignal<boolean> = signal(true);
  menuActions = inject(MenuActions);
  pageNumber = 1;
  pageSize = 24;
  private destroyRef = inject(DestroyRef);
  // private deviceScreenFamily = inject(DeviceScreenFamilyService);
  // protected currentScreenSize = this.deviceScreenFamily.currentDeviceScreenFamily;
  private locale = inject(LanguageService);
  ngOnInit(): void {
    this.getProducts();
  }

  constructor() {
    effect(() => {
      this.locale.currentLanguage();
      this.getProducts();
    });
  }

  getProducts() {
    const querryParams: ProductServiceParamsInterface = {
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      isPiezaUnica: true,
    };

    this.productService
      .getProducts(querryParams)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (res: ApiResponse<GetSpecialProductsData>) => {
          const productos = res.data.productos;
          this.products.set(productos);
          this.gettingProducts.set(false);
        },
        error: err => {
          console.log(`${this.TAG} ${err}`);
        },
      });
  }
  navigateToAllArtisansProducts() {
    this.menuActions.navigateToAllArtisansProducts();
  }
}
